import { connect } from 'react-redux';
import {
  fetchStaff,
  inviteStaff,
  removeInvitedStaff,
  switchAdmin,
} from '../../../store/modules/staff';

import User from '../components/User';
import { restoreObject } from '../../../store/modules/totaldata';
import { addFeedback } from '../../../store/modules/feedback';

const mapActionCreators = {
  fetchStaff,
  inviteStaff,
  removeInvitedStaff,
  restoreObject,
  addFeedback,
  switchAdmin,
};

const mapStateToProps = state => ({
  staffs: state.staff.staffs,
  fetching: state.staff.fetching,
  login: state.login,
  limits: state.limits.limits,
});

export default connect(mapStateToProps, mapActionCreators)(User);



// WEBPACK FOOTER //
// ./src/routes/User/containers/UserContainer.js